import { ArrowLeft, Dices, Moon } from "lucide-react";
import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { ApocalypseBoard } from "../components/ApocalypseBoard";
import { DolosNight } from "../components/DolosNight";
import { Footer } from "../components/Footer";
import { Reveal } from "../components/Reveal";
import { SectionHeading } from "../components/SectionHeading";

export default function SideGames() {
  const location = useLocation();

  // deep links — #dolos-night / #dolosway land flush on the game
  useEffect(() => {
    if (!location.hash) return undefined;
    const timer = window.setTimeout(() => {
      document.getElementById(location.hash.slice(1))?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 350);
    return () => window.clearTimeout(timer);
  }, [location.hash]);

  return (
    <main className="sidegames-page" data-testid="sidegames-page">
      <section className="sidegames-hero">
        <Link to="/" className="back-link" data-testid="sidegames-back-link">
          <ArrowLeft size={16} /> RETURN TO WORLD
        </Link>
        <Reveal immediate>
          <p className="eyebrow">BLACK-OPS NET ARCADE // SIDE GAMES</p>
          <h1>SIDE GAMES.</h1>
          <p>
            Off the main circuit, the arcade keeps two tables lit — a night-maze survival run against the horde,
            and the original five-runner dice board. Same stash, same bragging rights.
          </p>
        </Reveal>
        <Reveal delay={0.1} immediate>
          <div className="sidegames-jump" data-testid="sidegames-jump">
            <a href="#dolos-night" data-testid="sidegames-jump-night">
              <Moon size={13} /> DOLO'S NIGHT — MAZE
            </a>
            <a href="#dolosway" data-testid="sidegames-jump-dolosway">
              <Dices size={13} /> DOLOSWAY — BOARD
            </a>
          </div>
        </Reveal>
      </section>

      <section id="dolos-night" className="sidegames-game" data-testid="sidegames-dolos-night">
        <SectionHeading
          eyebrow="SIDE GAME 01 // DOLO'S NIGHT — MAZE SURVIVAL"
          title="Scavenge the dark. See the sun."
          text="An overhead maze survival run for 2-4 runners — you against up to three CPU rivals, a zombie horde, and the mutated dogs that hold the lanes. Grab supplies, slash the horde, set traps, hide in doorways, and hit the south gate before dawn. One shared maze per day — escapes outrank hauls on the weekly Night Board."
        />
        <Reveal delay={0.1}>
          <DolosNight />
        </Reveal>
      </section>

      <section id="dolosway" className="sidegames-game sidegames-board" data-testid="sidegames-dolosway">
        <SectionHeading
          eyebrow="SIDE GAME 02 // DOLOSWAY — DIGITAL BOARD GAME"
          title="Roll the bones. Own the wastes."
          text="Roll the dice to circle the apocalypse. Claim plots and hold them — rivals pay you toll. Collect parts to build the car, the home and the plane. Stockpile food and weapons: the strongest survives."
        />
        <Reveal delay={0.1}>
          <ApocalypseBoard />
        </Reveal>
      </section>

      <Footer />
    </main>
  );
}
